export default "__VITE_ASSET__BQ9Of7W3__"